import { AxiosInstance } from 'axios';
import Swal from 'sweetalert2';
import { translations } from '../../lib/consts';
import { authClient } from '../auth';

export function responseInterceptor(instance: AxiosInstance) {
    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            const originalRequest = error.config;

            if (
                error.response &&
                (error.response?.status === 500 || error.response.status === 422 || error.response.status === 400)
            ) {
                Swal.fire({
                    text: translations.ERROR_MESSAGE,
                    confirmButtonColor: '#c21b17',
                    confirmButtonText: translations.CONFIRM,
                    timer: 5000,
                    timerProgressBar: true,
                });
            }

            if (
                error.response &&
                (error.response.status === 403 || error.response.status === 401) &&
                !originalRequest._retry
            ) {
                originalRequest._retry = true;
                authClient.refreshToken().then(() => {
                    // Vladan Radovanovic 2025.10.02 - move JwtToken to Cookie set by server
                    // const token = authClient.getAccessToken();
                    //instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                    return instance(originalRequest);
                });
            }
            return Promise.reject(error);
        },
    );
}
